import { render } from "./packageManagementX.vue?vue&type=template&id=76a23fb5&scoped=true"
import script from "./packageManagementX.vue?vue&type=script&lang=js"
export * from "./packageManagementX.vue?vue&type=script&lang=js"

import "./packageManagementX.vue?vue&type=style&index=0&id=76a23fb5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-76a23fb5"

export default script